export const resizeTextarea = (el: HTMLTextAreaElement | null, px: number = 60, forceDefault = false) => {
  if (!el) return;

  if (!el.value) {
    el.style.height = `${px}px`
  } else {
    el.style.height = 'auto';
    if (forceDefault) {
      el.style.height = `${px}px`;
    }
    el.style.height = `${el.scrollHeight}px`;
  }
};

export const stopEvent = (e: any) => {
  e.preventDefault
  e.stopPropagation
}